import { useBackgroundSessionRefresh } from "@features/account/useBackgroundSessionRefresh"
import { FlyingCarpet } from "@features/flying-carpet/FlyingCarpet"
import { Footer } from "@features/site/Footer"
import { Header } from "@features/site/Header"
import { useSpektrixActions } from "@features/site/useSpektrixActions"
import { Checkout } from "@features/tickets/Checkout"
import { ScrollRestoration, useRoute } from "eddev/routing"
import { defineView } from "eddev/views"
import { cn } from "tailwind-variants"

export default defineView("_app", (props) => {
  const route = useRoute()
  useBackgroundSessionRefresh()
  useSpektrixActions()
  return (
    <>
      <ScrollRestoration />
      <Header />
      {props.children}
      <Footer />
      <Checkout />
      <FlyingCarpet />
    </>
  )
})
